import { AiOutlineDelete } from "react-icons/ai";
import { useEffect, useState } from "react";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { generate } from "random-words";
import { Loading } from "notiflix";
import { DeleteRequest } from "@/lib/http";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

const DeactivateAccount = () => {
  const [openTab, setOpenTab] = useState(false);
  const [securityPhrase, setSecurityPhrase] = useState("");
  const [input, setInput] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    setSecurityPhrase(generate({ exactly: 3, join: "-" }));
  }, []);

  const handleDeactivateAccount = async () => {
    Loading.hourglass("Deleting Account");
    const { err } = await DeleteRequest({
      url: "/api/self",
    });

    if (!err) {
      toast.warning(
        "Your account has been deleted successfully, Sad to see you go",
      );
      localStorage.removeItem("user-token");
      navigate("/login");
    } else {
      alert(err);
    }
    Loading.remove();
  };

  return (
    <div className="flex items-center gap-2">
      <div className="flex size-12 items-center justify-center rounded-full bg-gray-100">
        <AiOutlineDelete size={20} className="text-primary" />
      </div>

      <div onClick={() => setOpenTab(true)} className="cursor-pointer">
        <h1 className="font-semibold">Deactivate/Delete Account</h1>
        <p className="dark:text-darkGray text-[12px] font-medium text-gray-500">
          Account Deactivation
        </p>
      </div>

      <AlertDialog open={openTab} onOpenChange={setOpenTab}>
        <AlertDialogContent className="font-jakarta">
          <AlertDialogHeader>
            <AlertDialogTitle>Deactivate Account</AlertDialogTitle>
            <AlertDialogDescription className="space-y-4">
              <p>
                Are you sure you want to deactivate your account? This action
                cannot be undone.
              </p>
              <p>
                Please type{" "}
                <span className="font-semibold">{securityPhrase}</span> in the
                input field below to confirm.
              </p>
              <input
                type="text"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                className="w-full rounded-md border p-2"
                placeholder="Enter security phrase"
              />
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel className="dark:bg-darkBg bg-white outline-none">
              Cancel
            </AlertDialogCancel>
            <AlertDialogAction
              onClick={() => {
                setSecurityPhrase(generate({ exactly: 3, join: "-" }));
                setInput("");
                const proceed = window.confirm(
                  "Are you really sure you want to delete your account. Beyond this point there is no turning back!!",
                );
                if (proceed) {
                  handleDeactivateAccount();
                } else {
                  setOpenTab(false);
                }
              }}
              className="bg-red-600 text-white hover:bg-red-700"
              disabled={input !== securityPhrase}
            >
              Deactivate
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};

export default DeactivateAccount;
